import {createFileRoute} from '@tanstack/react-router'

import Menu from '@/views/Internal/Menu'

export const Route = createFileRoute('/i-n-t-e-r-n-a-l/menu/')({
  component: Menu,
})
